import React, {useEffect, useState} from 'react'
import {Box, Flex, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {FormattedMessage, useIntl} from 'react-intl'
import Search from '../../components/search'
import ProductRegistrationImageContainer from './partials/product-registration-image-container'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import routingObject from '../../utils/static-routes'
import ProductRegistrationHeader from './partials/product-registration-header'
import ProductRegistrationStepper from './partials/product-registration-stepper'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const ProductSearch = () => {
    const styles = useMultiStyleConfig('ProductRegistration', {variant: 'productSearch'})
    const {site} = useMultiSite()
    const brandName = site.id.split('-')[0]
    const [searchResults, setSearchResults] = useState([])
    const [suggestionRegistration, setSuggestionRegistration] = useState([])
    const [productSelect, setProductSelect] = useState('')
    const navigate = useNavigation()

    const SearchBar = (props) => {
        const intl = useIntl()
        const placeholder = intl.formatMessage({
            id: 'product_registration.search',
            defaultMessage: 'Search by SKU or Model Number',
        })
        return (
            <Search
                aria-label={placeholder}
                searchInputPlaceholder={placeholder}
                variant={'productSearch'}
                setSearchResults={setSearchResults}
                isProductRegistration
                setProductSelect={setProductSelect}
                setSuggestionRegistration={setSuggestionRegistration}
                shouldRemoveLabel
                showSpellingMessage={
                    searchResults?.hits === undefined &&
                    searchResults?.length !== 0 &&
                    !suggestionRegistration?.productId
                }
                {...props}
            />
        )
    }
    useEffect(() => {
        if (
            (searchResults &&
                productSelect.length !== 0 &&
                searchResults?.hits !== undefined &&
                searchResults?.length !== 0) ||
            (suggestionRegistration?.productId && searchResults && productSelect)
        ) {
            navigate(
                `${routingObject.PRODUCT_REGISTRATION_PATH}/select?text=` +
                    productSelect.replaceAll(' ', '-'),
            )
        }
    }, [searchResults, productSelect, suggestionRegistration])

    let skuImage
    switch (brandName) {
        case 'kenwood':
            skuImage = getAssetUrl(`static/img/product-registration/skuImage-kenwood.png`)
            break
        default: // delonghi image is fallback
            skuImage = getAssetUrl(`static/img/product-registration/skuImage-delonghi.png`)
    }
    let modelNumberImage
    switch (brandName) {
        case 'kenwood':
            modelNumberImage = getAssetUrl(
                `static/img/product-registration/modelNumber-kenwood.png`,
            )
            break
        case 'nutribullet':
            modelNumberImage = getAssetUrl(
                `static/img/product-registration/modelNumber-nutribullet.png`,
            )
            break
        default: // delonghi image is fallback
            modelNumberImage = getAssetUrl(
                `static/img/product-registration/modelNumber-delonghi.png`,
            )
    }

    const skuTitle = (
        <FormattedMessage
            id="product_registration.sku_title"
            defaultMessage="Where can i find the SKU code?"
        />
    )
    const skuDescription = (
        <FormattedMessage
            id="product_registration.sku_description"
            defaultMessage="You can find the SKU code on the box of your product, usually on the long side at the top left."
        />
    )
    const modelTitle = (
        <FormattedMessage
            id="product_registration.model_title"
            defaultMessage="Where can i find the Model Number?"
        />
    )
    const modelDescription = (
        <FormattedMessage
            id="product_registration.model_description"
            defaultMessage="You can find the Model Number am auctor eget quam vitae fringilla. Have a different model? Search for it <u>here</u>."
            values={{
                u: (chunks) => (
                    <u>
                        <a
                            href="https://www.delonghi.com/it-it/support/find-serial-number"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {chunks}
                        </a>
                    </u>
                ),
            }}
        />
    )

    return (
        <Flex {...styles.container} layerStyle={'page'}>
            <Flex {...styles.headerStepperContainer}>
                <ProductRegistrationHeader index={1} variant={'product'} />
                <ProductRegistrationStepper index={1} />
            </Flex>
            <Flex {...styles.bottomContainer}>
                <Flex {...styles.labelSearchOuterContainer}>
                    <Flex {...styles.labelSearchInnerContainer}>
                        <Text {...styles.labelSearchTitle}>
                            <FormattedMessage
                                id="product_registration.enter_sku_or_model"
                                defaultMessage="Enter the SKU code or Model Number of your product"
                            />
                        </Text>
                        <Text {...styles.labelSearchDescription}>
                            <FormattedMessage
                                id="product_registration.no_sku_enter_model"
                                defaultMessage="Don't have the SKU code? Enter the Model Number of the product you want to register."
                            />
                        </Text>
                        <Box {...styles.searchBarOuterContainer}>
                            <Box {...styles.searchBarContainer}>
                                <SearchBar />
                            </Box>
                            <Text {...styles.exampleLabel}>
                                <FormattedMessage
                                    id="product_registration.sku_examples"
                                    defaultMessage="Examples of valid SKU codes: <i>0W22234994007, 0W22234994007, 0W22234994007</i>"
                                    values={{
                                        i: (chunks) => <i>{chunks}</i>,
                                    }}
                                />
                            </Text>
                            <Text {...styles.exampleLabel}>
                                <FormattedMessage
                                    id="product_registration.model_examples"
                                    defaultMessage="Examples of valid Model Numbers: <i>EXAM.000.999.009, EXAM.000.999.009</i>"
                                    values={{
                                        i: (chunks) => <i>{chunks}</i>,
                                    }}
                                />
                            </Text>
                        </Box>
                    </Flex>
                </Flex>
                <Flex {...styles.infoBannerBox}>
                    <ProductRegistrationImageContainer
                        image={skuImage}
                        title={skuTitle}
                        description={skuDescription}
                        variant="productSearch"
                    />
                    <ProductRegistrationImageContainer
                        image={modelNumberImage}
                        title={modelTitle}
                        description={modelDescription}
                        variant="productSearch"
                    />
                </Flex>
            </Flex>
        </Flex>
    )
}

export default ProductSearch
